import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { RsIcon } from '../components/icons'
import axios from 'axios'
import toast from 'react-hot-toast'
import { useAuth } from '../contexts/AuthContext'
import { homePathForRole } from '../utils/routes'
import { AuthSplitLayout, AuthLogo } from '../components/Auth/AuthShell'

export default function OAuthCallback() {
  const { refreshUser } = useAuth()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [status, setStatus] = useState('processing')

  useEffect(() => {
    const run = async () => {
      const success = searchParams.get('success') === '1'
      const provider = searchParams.get('provider')
      const flow = searchParams.get('flow') || 'signup'
      const error = searchParams.get('error')
      const message = searchParams.get('message')

      if (!success) {
        setStatus('error')
        toast.error(message || error || 'OAuth authorization failed')
        return
      }

      if (flow === 'login') {
        const token = searchParams.get('token')
        if (token) {
          localStorage.setItem('token', token)
          axios.defaults.headers.common.Authorization = `Bearer ${token}`
          const me = refreshUser ? await refreshUser() : null
          setStatus('ok')
          toast.success('Login successful')
          setTimeout(() => navigate(homePathForRole(me?.role)), 800)
          return
        }
        setStatus('error')
        return
      }

      const oauthUid = searchParams.get('oauthUid')
      const displayName = searchParams.get('displayName')
      const returnUrl = searchParams.get('returnUrl') || '/signup/complete-profile'
      const dev = searchParams.get('dev') === '1'

      sessionStorage.setItem(
        'oauth_result',
        JSON.stringify({ provider, oauthUid, displayName, dev, email: searchParams.get('email') })
      )

      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: 'rotationstreet_oauth', provider, oauthUid, displayName, dev },
          window.location.origin
        )
        setStatus('ok')
        setTimeout(() => window.close(), 600)
        return
      }

      setStatus('ok')
      const target = returnUrl.includes('?') ? `${returnUrl}&oauth=1` : `${returnUrl}?oauth=1`
      setTimeout(() => navigate(target), 800)
    }

    run()
  }, [searchParams, navigate, refreshUser])

  return (
    <AuthSplitLayout
      title="Almost there"
      description="Completing secure sign-in with your social account."
      features={[]}
    >
      <AuthLogo />
      <div style={{ textAlign: 'center', padding: '24px 0' }}>
        {status === 'processing' && (
          <>
            <RsIcon name="loader" size={40} spin style={{ margin: '0 auto 16px', color: '#0f3d8a' }} />
            <p style={{ fontWeight: 600, color: '#1a1a2e' }}>Completing authorization…</p>
          </>
        )}
        {status === 'ok' && (
          <>
            <RsIcon name="checkCircle" size={40} style={{ margin: '0 auto 16px', color: '#67c23a' }} />
            <p style={{ fontWeight: 600, color: '#1a1a2e' }}>Authorization successful</p>
            <p style={{ fontSize: 14, color: '#909399', marginTop: 8 }}>Returning to profile setup…</p>
          </>
        )}
        {status === 'error' && (
          <>
            <RsIcon name="xCircle" size={40} style={{ margin: '0 auto 16px', color: '#f56c6c' }} />
            <p style={{ fontWeight: 600, color: '#1a1a2e' }}>Authorization incomplete</p>
            <Link
              to="/signup"
              className="auth-btn auth-btn-primary"
              style={{ display: 'inline-block', marginTop: 20, textDecoration: 'none' }}
            >
              Back to Sign Up
            </Link>
          </>
        )}
      </div>
    </AuthSplitLayout>
  )
}
